const HomeIcon = () => {
    return ( 
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.8334 15.7917V6.93754C16.8334 6.77583 16.7958 6.61633 16.7234 6.47169C16.6511 6.32705 16.5461 6.20124 16.4168 6.10421L9.12508 0.635457C8.94477 0.500226 8.72547 0.427124 8.50008 0.427124C8.2747 0.427124 8.05539 0.500226 7.87508 0.635457L0.583415 6.10421C0.454044 6.20124 0.34904 6.32705 0.27672 6.47169C0.204399 6.61633 0.166748 6.77583 0.166748 6.93754V15.7917C0.166748 16.068 0.276495 16.3329 0.471845 16.5283C0.667196 16.7236 0.932148 16.8334 1.20841 16.8334H15.7918C16.068 16.8334 16.333 16.7236 16.5283 16.5283C16.7237 16.3329 16.8334 16.068 16.8334 15.7917Z" fill="url(#paint0_linear_145_371)" className="fill" />
            <defs>
            <linearGradient id="paint0_linear_145_371" x1="0.166748" y1="0.166707" x2="16.8334" y2="16.8334" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF512F"/>
                <stop offset="1" stopColor="#DD2476"/>
            </linearGradient>
            </defs>
        </svg>
    );
}
 
export default HomeIcon;